<nav>
    <div *ngFor="let item of menuItems; let i = index" #menuItem closeOnOutsideClick [items]="items" (outsideClick)="closeMenu()">
        <!-- menu item -->
        <app-horizontal-item [isActive]="activeParentIndex === i" [item]="item" (toggleSubmenuClick)="onToggleSubmenuClick($event, i)"></app-horizontal-item>

        <!-- SUBLEVEL -->
        <ul *ngIf="item.submenu" [ngClass]="{'opening': openMenu && activeIndex === i}" class="horizontal-subnav">
            <li *ngFor="let subitem of item.submenu; let indexLevel1 = index">
                <!-- menu item -->
                <app-horizontal-item [item]="subitem" (toggleSubmenuClick)="onToggleSubmenuClick($event)"></app-horizontal-item>
                
                <!-- SUBLEVEL 2 -->
                <ul *ngIf="subitem.submenu" class="horizontal-subnav level2">    
                    <li *ngFor="let subitem2 of subitem.submenu">
                        <!-- menu item -->
                        <app-horizontal-item [item]="subitem2" (toggleSubmenuClick)="onToggleSubmenuClick($event)"></app-horizontal-item>

                        <!-- SUBLEVEL 3 -->
                        <ul *ngIf="subitem2.submenu" class="horizontal-subnav level3">
                            <li *ngFor="let subitem3 of subitem2.submenu">
                                <!-- menu item -->
                                <app-horizontal-item [item]="subitem3" (toggleSubmenuClick)="onToggleSubmenuClick($event)"></app-horizontal-item>

                                <!-- SUBLEVEL 4 -->
                                <ul *ngIf="subitem3.submenu" class="horizontal-subnav level4">
                                    <li *ngFor="let subitem4 of subitem3.submenu">
                                        <!-- menu item -->
                                        <app-horizontal-item [item]="subitem4" (toggleSubmenuClick)="onToggleSubmenuClick($event)"></app-horizontal-item>
                                    </li>
                                </ul>
                            </li>
                        </ul>
                    </li>
                </ul>
            <li>
        </ul>
    </div>

    <div class="engage-switch" *ngIf="!isSupport && menuService.hasInvitedeskEngagePermission">
        <a class="nav-link" data-testid="switch-to-engage" [tooltip]="isEngagePreferred ? '' : ('LAYOUT.HEADER.SWITCHTOENGAGE' | translate)" placement="bottom" container="body" (click)="toggleEngage($event)" href="#">
            <em class="fa mr-1" [class.fa-toggle-on]="isEngagePreferred" [class.fa-toggle-off]="!isEngagePreferred"></em> {{ 'LAYOUT.HEADER.USEINVITEDESKENGAGE' | translate }}
        </a>
    </div>
</nav>
